import { createSlice } from "@reduxjs/toolkit";

const uiSlice = createSlice({
  name: "ui",
  initialState: { notification: null, customersLoading: false, licensesLoading: false, usersLoading: false },
  reducers: {
    enqueNotification(state, action) {     
      state.notification = action.payload;
    },
    enqueErrorNotification(state, action) {
      state.notification = {
        message: action.payload.message,
        variant: 'error',
      };
    },    
    clearNotification(state) {
      state.notification = null;
    },   
    setCustomersLoading(state, action) {
      state.customersLoading = action.payload;
    },
    setLicensesLoading(state, action) {
      state.licensesLoading = action.payload;
    },
    setUsersLoading(state, action) {
      state.usersLoading = action.payload;
    }
  },
});

export const uiActions = uiSlice.actions;
export default uiSlice.reducer;
